import { React, useEffect, useState, useMemo, useCallback } from 'react';
import { Dialog, Popover, Tooltip, Box } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { projectInuseDetailAtom, projectListInCorporationByUserIdAtom } from '@/state/atom/projectAtom';
import LoadingPanel from '../common/LoadingPanel';
import ErrorMessageHeader from '../common/ErrorMessageHeader';
import '../common/ErrorMessageHeader.css';
import { 
    setPanelSelector,
    triggerReloadTicketListByPanelType, 
    triggerReloadTab,
    closePanelTabSelector, 
    updatePanelAfterCreateTicketSelector
} from '@/state/selector/panelSelector';
import {
    triggerReLoadKnowledgeTicketDetailAtom
} from '@/state/atom/ticketKnowledgeAtom';
import { updateUserWorkspacePanel } from '@/common/utils/ServiceFactoryUtil';
import { cloneDeep } from 'lodash';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { userAtom } from '@/state/atom/userAtom';
import {
    acceptBackToDraftButton,
    acceptDeleteKnowledgeButton,
    acceptRestoreKnowledgeTicket,
    acceptHardDeleteKnowledgeTicket,
    closeCallbackBackToDraftButton,
    closeCallbackDeleteKnowledgeButton,
    closeCallbackRestoreKnowledgeTicketButton,
    getTicketDetailHandler,
    isSettingPermissionChanged,
    handleConfirmAccessDenied,
    hasEditPermissionWithSpecialCase,
} from './handler/DetailTicketHandler';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import CustomSchema from '@/schema/CustomSchema';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { multiPanelAtom, closeTabId, panelInitDataAtom, lastActivePanelIdAtom} from '@/state/atom/panelAtom';
import { DialogConfirmCancelEditTicket } from '../chatThread/editTicketDialog/DialogConfirmCancelEditTicket';
//Edit Ticket
import { API, I18n } from 'aws-amplify';
import { bulkCreateTagItem } from '@/service/formManagementService';
import { useSnackbar } from 'notistack';
import {
    updateTabNameAfterEditTicket,
    submitUpdateTicketKnowledge,
} from './handler/DetailTicketHandler';

import { handlerShowButtonEditTicket, isShowFieldAIPDFPageSplitStatus, isShowFieldEventTypeChatThread, isShowReasoningEffortField } from '../ticketList/handler/KnowledgeTicketHandler';
import SettingPermissionKnowledgeTicket from '../ticketList/knowledge/SettingPermissionKnowledgeTicket';
import AiAutoLog from '../ticketList/knowledge/AiAutoLog';
import SDautoLog from '../ticketList/knowledge/SDautoLog';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';
import { getTicketById } from '@/service/ticketService';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import './DetailTicketKnowledge.css'

import moment from 'moment';
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import { getPanelInitData, updatePanelInitData, removePanelInitData } from '@/component/multiPanel/panel/handler/PanelHandler';
import { helpdeskTicketLastUserActionAtom } from '@/state/atom/ticketAtom';
import crypto from 'crypto-js';
import { isDisplayExtractText, isDisplayVectorUrlAndTotalToken } from '@/component/ticketKnowledge/handler/DetailTicketHandler';
import { validateExceedSizeOfFieldTicket } from '@/component/common/ValidateTicket';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import { viewTicketKnowledgeDetailDuplicate, closePanelTabDetailTicket } from '../ticketList/handler/TicketHandler';
import { activeFormForDuplicate } from '../formManagement/handler/FormListHandler';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { isInputAllFieldRequiredWhenEditTicket } from '../chatThread/handler/DetailTicketHandler';
import Bookmark from './elements/Bookmark/Bookmark';
import TagDefaultBookmark from './elements/Bookmark/TagDefaultBookmark';
import { signOut } from '@/service/authenService';
import UserTagPrivateBookmarkCount from './elements/Bookmark/UserTagPrivateBookmarkCount';
import TaggedBookmarkListName from './elements/Bookmark/TaggedBookmarkListName';
import AssigneeUI from '../formManagement/fieldUI/AssigneeFieldUI';
import DetailKnowledgeGroupActionButton from './DetailKnowledgeGroupActionButton';
import DetailKnowledgeViewModeGroupButton from './DetailKnowledgeViewModeGroupButton';

import { getCorporationById } from '@/service/organizationService';
import { getProjectById } from '@/service/projectService';
import { getProjectMemberList } from '@/component/ticketList/handler/HelpDeskTicketListHandler';
import { getAssignList } from '@/component/ticketList/handler/TicketListHandler';
import { Storage } from 'aws-amplify';
import { PropTypes } from 'prop-types';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { ButtonOption, FlagMessageCopyLink } from '../ticketList/DetailTicketList';
import AttachFileChatPost from '../attachFile/AttachFileChatPost';
import WrapRenderFieldUI from './WrapRenderFieldUI';
import TelephonePromptLog from '../ticketList/knowledge/TelephonePromptLog'

// AI Telephone date fields that should be rendered as pairs (2 fields per row)

// Use constant values instead of hardcoded field names for AI Telephone paired fields
const AI_TELEPHONE_PAIRED_FIELDS = {
    [Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME]: Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME,
    [Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE]: Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE,
};
const AI_TELEPHONE_SKIP_FIELDS = Object.values(AI_TELEPHONE_PAIRED_FIELDS);

DetailTicketKnowledge.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    ticketId: PropTypes.any
};

export default function DetailTicketKnowledge(props) {
    
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const isGeneralUser = Utils.isGeneralUser(currentUserDetail);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    const [selectedProject, setSelectedProject] = useRecoilState(projectInuseDetailAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const listB2BCustomer = useRecoilValue(getListActiveB2BCustomerSelector);
    const listB2BHelpdesk = useRecoilValue(getListActiveB2BHelpdeskSelector);

    const [triggerReLoadKnowledgeTicketDetail, setTriggerReLoadKnowledgeTicketDetail] = useRecoilState(
        triggerReLoadKnowledgeTicketDetailAtom
    );

    const [detailTicket, setDetailTicket] = useState({});
    const [fieldListDefaultData, setFieldListDefaultData] = useState([]);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const [listFieldData, setListFieldData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdited, setIsEdited] = useState(false);
    const [listFieldEdited, setListFieldEdited] = useState([]);
    const [fileUploadList, setFileUploadList] = useState([]);
    const [fileUpdatedList, setFileUpdatedList] = useState([]);
    const [fileUploading, setFileUploading] = useState({});
    const [mapDataIdToId, setMapDataIdToId] = useState({});
    const [isDisplayEditTicket, setIsDisplayEditTicket] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [formDetail, setFormDetail] = useState({});
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [ticketOutline, setTicketOutline] = useState('');
    const [settingTitle, setSettingTitle] = useState([]);

    const [dataSettingDefaults, setDataSettingDefaults] = useState({});
    const [viewPermissions, setViewPermissions] = useState([]);
    const [editPermissions, setEditPermissions] = useState([]);
    const [additionalViewPermissions, setAdditionalViewPermissions] = useState([]);
    const [additionalEditPermissions, setAdditionalEditPermissions] = useState([]);
    const [chatPermission, setChatPermission] = useState('');

    const [hasEditSettingPermissions, setHasEditSettingPermissions] = useState(false);
    const [hasEditFieldPermissions, setHasEditFieldPermissions] = useState(false);
    const [hasChatPermission, setHasChatPermission] = useState(false);
    const [hasViewPermission, setHasViewPermission] = useState(false);
    const [isConfirmCancelEditTicket, setIsConfirmCancelEditTicket] = useState(false);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [isOpenModalReloadPageMain, setIsOpenModalReloadPageMain] = useState(false);
    const [isOpenModalTicketDeleted, setIsOpenModalTicketDeleted] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    
    const [disableButtonCallBack, setDisableButtonCallBack] = useState(false);

    const [isShowAiAutoLog, setIsShowAiAutoLog] = useState(false);
    const [isShowSDautoLog, setIsShowSDautoLog] = useState(false);
    
    // Delete button
    const [isOpenDialogConfirmDeleteKnowledge, setIsOpenDialogConfirmDeleteKnowledge] = useState(false);
    const reloadPanelAfterSoftDeleteTicketByPanelType = useSetRecoilState(triggerReloadTab);
    
    // Back to draft
    const [isOpenDialogConfirmBackToDraft, setIsOpenDialogConfirmBackToDraft] = useState(false);
    const updatePanelAfterBackToDraft = useSetRecoilState(updatePanelAfterCreateTicketSelector);
    
    // Restore button
    const [isShowDialogRestoreTicket, setIsShowDialogRestoreTicket] = useState(false);

    // Delete button
    const [isShowDialogDeleteTicket, setIsShowDialogDeleteTicket] = useState(false);

    useEffect(() => {
        registerEditTicket('fileUploadList');
    }, [])

    const validateEditTicket = useForm({
        mode: 'all',
        resolver: yupResolver(CustomSchema(fieldListDefaultData))
    });
    const handleSubmitEditTicket = validateEditTicket.handleSubmit;
    const errorEditTicket = validateEditTicket.errors;
    const clearErrors = validateEditTicket.clearErrors;
    const setValueEditTicket = validateEditTicket.setValue;
    const registerEditTicket = validateEditTicket.register;
    const getValuesEditTicket = validateEditTicket.getValues;
    const setErrorEditTicket = validateEditTicket.setError;
    const triggerValidate = validateEditTicket.trigger;    
    const { watch } = validateEditTicket;
    const allFormData = watch(); 

    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [isTagList, setIsTagList] = useState(false);
    const [tagListValue, setTagListValue] = useState([]);
    const [isEditTicket, setIsEditTicket ] = useState(false);
    const [corporationAffiliationTicket, setCorporationAffiliationTicket] = useState({});
    const [titleLineNumber, setSettingTitleLineNumber] = useState(0);

    // Switch tab state
    const [panelInitData, setPanelInitData] = useRecoilState(panelInitDataAtom);
    const [currentPanelInitData, setCurrentPanelInitData] = useState({});
    const lastActivePanelId = useRecoilValue(lastActivePanelIdAtom);
    const [lastUserAction, setLastUserAction] = useRecoilState(helpdeskTicketLastUserActionAtom);

    const [isShowExtractedText, setIsShowExtractedText] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenNotFoundTicketPopup,setIsOpenNotFoundTicketPopup] = useState(false)
    const [restoreTicketErrorPopupData, setRestoreTicketErrorPopupData] = useState({
        message: I18n.get('MSG-SD-RESTORE-DUPLICATED-TITLE-SCRIPT'),
        isOpen: false
    });
    const [isOpenModalActiveForm, setIsOpenModalActiveForm] = useState(false);
    const [isOpenModalActiveAITelephoneAgent, setIsOpenModalActiveAITelephoneAgent] = useState(false);
    const [isOpenModalTelephoneAgentDisabled, setIsOpenModalTelephoneAgentDisabled] = useState(false);
    const [formList, setFormList] = useRecoilState(formListOfProjectSelector);
    const [isShowPopupLogout, setIsShowPopupLogout] = useState(false);

    const [errorMessageHeader, setErrorMessageHeader] = useState('');
    // const [isLoadingNotRefreshData, setIsLoadingNotRefreshData] = useState(false)
    /**
     * created for ai auto. this state will be set options by dependent field. ex: ai auto. selected ticket type field , will be query form list by ticket type.
     * this state value is format array object with key which is any. !) with ai auto: key is sysField of dependent field.
     */
    const [optionsOfTagField, setOptionsOfTagField] = useState({})
    const [aiAutoSelectedData, setAIAutoSelectedData] = useState({});
    const [sdautoSelectedData, setSdautoSelectedData] = useState({});
    const [aiTelephoneSelectedData, setAITelephoneSelectedData] = useState({});
    const [aiTelephoneEndDateValue, setAiTelephoneEndDateValue] = useState(null);

    const userOfProjectList = useRecoilValue(projectListInCorporationByUserIdAtom);
    const [ticketAffiliationProject, setTicketAffiliationProject] = useState({})
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: I18n.get('MSG-CM-DELETED-CONTENT'),
        confirmTxt: I18n.get('CM-BUTTON-OK')
    });

    // Assignee
    const [currentAssigneeUserData, setCurrentAssigneeUserData] = useState({});
    const [newAssigneeData, setNewAssigneeData] = useState({});
    const [newAssignee, setNewAssignee] = useState('');
    const [assignList, setAssignList] = useState([]);
    const [flagReset, setFlagReset] = useState(false);
    const [isMe, setIsMe] = useState(false);
    

    // View/edit mode
    const [displayMode, setDisplayMode] = useState(Constant.DISPLAY_MODE.VIEW);

    const [openPreviewImage, setOpenPreviewImage] = useState(null);
    const [openOption, setOpenOption] = useState(null);
    const [openFileOption, setOpenFileOption] = useState(null);
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    const [isShowAITelephonePromptLog, setIsShowAITelephonePromptLog] = useState(false);

    const argsAll = {
        ...props,
        errorMessageHeader,
        setErrorMessageHeader,
        API: props?.API,
        currentUserDetail,
        corporationDetail,
        selectedProject,
        isProjectManager,
        listB2BCustomer,
        listB2BHelpdesk,
        detailTicket,
        setDetailTicket,
        fieldListDefaultData,
        setFieldListDefaultData,
        listFieldData,
        setListFieldData,
        isLoading,
        setIsLoading,
        isEdited,
        setIsEdited,
        ticketOutline,
        setTicketOutline,
        settingTitle, 
        setSettingTitle,
        formDetail,
        setFormDetail,
        listFieldEdited,
        setListFieldEdited,
        setMapDataIdToId,
        
        dataSettingDefaults, 
        setDataSettingDefaults,
        viewPermissions, 
        setViewPermissions,
        editPermissions, 
        setEditPermissions,
        additionalViewPermissions, 
        setAdditionalViewPermissions,
        additionalEditPermissions, 
        setAdditionalEditPermissions,
        chatPermission, 
        setChatPermission,

        hasViewPermission,
        setHasViewPermission,
        hasEditSettingPermissions,
        setHasEditSettingPermissions,
        hasEditFieldPermissions,
        setHasEditFieldPermissions,
        hasChatPermission,
        setHasChatPermission,
        reloadTicketListByPanelType,
        
        panelList,
        setPanelList,
        closePanelTab,

        isOpenDialogConfirmDeleteKnowledge, 
        setIsOpenDialogConfirmDeleteKnowledge,
        isOpenDialogConfirmBackToDraft, 
        setIsOpenDialogConfirmBackToDraft,
        isShowDialogRestoreTicket,
        setIsShowDialogRestoreTicket,
        isShowDialogDeleteTicket,
        setIsShowDialogDeleteTicket,
        reloadPanelAfterSoftDeleteTicketByPanelType,
        enqueueSnackbar,
        updatePanelAfterBackToDraft,

        isOpenModalReloadPageMain, 
        setIsOpenModalReloadPageMain,
        isTagList,
        setIsTagList,
        tagListValue,
        setTagListValue,
        isEditTicket,
        setIsEditTicket,
        fileUploadList,
        setFileUploadList,
        fileUpdatedList,
        setFileUploading,
        setCorporationAffiliationTicket,
        currentPanelInitData,
        setCurrentPanelInitData,
        lastUserAction,
        setLastUserAction,
        titleLineNumber,
        setSettingTitleLineNumber,
        setIsOpenModalTicketDeleted,
        setIsOpenAccessDeniedPopup,
        isOpenModalReloadPage,
        setIsOpenModalReloadPage,
        addNewPanel,
        setIsShowPopupLogout,
        ticketAffiliationProject,
        corporationAffiliationTicket,
        setTicketAffiliationProject,

        newAssigneeData,
        setNewAssigneeData,
        newAssignee,
        setNewAssignee,
        flagReset,
        setFlagReset,
        setAssignList,
        setCurrentAssigneeUserData,
        aiAutoSelectedData,
        sdautoSelectedData,
        setSdautoSelectedData,
        aiTelephoneSelectedData,
        setAITelephoneSelectedData,
        setErrorEditTicket,
        setRestoreTicketErrorPopupData,
        panelInitData,
        displayMode
    };

    const currentTabData = useMemo(() => {
        if (!panelInitData) return;
        const panel = panelInitData.find(p => p.id === props.panelId);
        if (!panel) return;
        const tab = (panel?.tabList || []).find(t => t.id === props.tabId)?.data;
        return tab
    }, [panelInitData, props.tabId, props.panelId]);

    const filterDefaultValue = (value) => {
        if(Utils.isEmptyArray(value)) {
            return [];
        }

        let newValue = []
        let newFileUploadedList = value.filter(item => !Utils.isImageFile(item.fileName));
        // get list image
        let fileImageList = value.filter(item => Utils.isImageFile(item.fileName));
        newValue = [...newFileUploadedList, ...fileImageList]
        return newValue
    }

    const handleGetTicketDetail = async () => {
        setIsLoading(true);

        const ticketDetail = await getTicketDetailHandler(
            argsAll,
            props.ticketId,
            props.panelId,
            props.tabId,
            props.triggerReload ? {} : panelInitData,
            panelList
        );

        if (!ticketDetail) {
            setIsLoading(false);
            return;
        }
        // validate display AI Auto Log
        const isAIAutoForm = Utils.isSystemAIAutoForm(ticketDetail.formDetail);
        const isUsingAIAuto = Utils.isCorporationOnAIAuto(corporationDetail);
        
        setIsShowAiAutoLog(isAIAutoForm && isUsingAIAuto)

        // validate display SD Auto Log
        const isSDAutoForm = ticketDetail.formDetail?.definitionVariant === Constant.FORM_VARIANT.SD_AUTO;
        const isUsingSDAuto = Utils.isCorporationOnSDAuto(corporationDetail);
        
        setIsShowSDautoLog(isSDAutoForm && isUsingSDAuto);

        const isAITelephonePromptForm =
            ticketDetail.formDetail?.definitionVariant ===
                Constant.FORM_VARIANT.AI_TELEPHONE_PROMPT ||
            ticketDetail.formDetail?.definitionVariant ===
                Constant.FORM_VARIANT.AI_TRAINING_PROMPT;
        const isProjectActiveAITelephoneAgent = Utils.isProjectOnAiTelephoneAgent(selectedProject) && Utils.isEnableSettingTelephoneAgent(corporationDetail) && ticketDetail.affiliationOrganization === corporationDetail.id;
        setIsShowAITelephonePromptLog(isAITelephonePromptForm && isProjectActiveAITelephoneAgent);
        //always stand before add panel to ensure enough data to init panel. ensure init panel data is correct.
        await handleAfterGetTicketDetail(ticketDetail)

        let currentPanelInitDataRes = getPanelInitData(props.panelId, props.tabId, panelInitData);
        if (currentPanelInitDataRes && !Utils.isEmptyObject(currentPanelInitDataRes)) {
            setCurrentPanelInitData(currentPanelInitDataRes);
            if (currentPanelInitDataRes.isEditedData) {
                setIsEdited(true);
            }
            if (currentPanelInitDataRes.fileUploadList) {
                setFileUploadList(currentPanelInitDataRes.fileUploadList);
            }
            if (currentPanelInitDataRes.fileUpdatedList) {
                setFileUpdatedList(filterDefaultValue(currentPanelInitDataRes.fileUpdatedList));
            }
            if (currentPanelInitDataRes.aiAutoSelectedData) {
                setAIAutoSelectedData(currentPanelInitDataRes.aiAutoSelectedData);
            }
            if (currentPanelInitDataRes.sdautoSelectedData) {
                setSdautoSelectedData(currentPanelInitDataRes.sdautoSelectedData)
            }
            if (currentPanelInitDataRes.aiTelephoneSelectedData) {
                setAITelephoneSelectedData(currentPanelInitDataRes.aiTelephoneSelectedData);
            }
            if (currentPanelInitDataRes.displayMode) {
                setDisplayMode(currentPanelInitDataRes.displayMode);
            }
        }
        setIsLoading(false);
        // fake
        return ticketDetail
    }

    const handleAfterGetTicketDetail = async (ticketDetail) => {
        let ticketCorpData = corporationDetail;
        if (ticketDetail.affiliationOrganization !== corporationDetail?.id) {
            ticketCorpData = await getCorporationById(props.API, ticketDetail.affiliationOrganization);
        }
        setCorporationAffiliationTicket(ticketCorpData);

        let ticketProjectData = selectedProject;
        if (ticketDetail.affiliationProject !== selectedProject?.id) {
            ticketProjectData = await getProjectById(props.API, ticketDetail?.affiliationProject)
        }
        setTicketAffiliationProject(ticketProjectData);

        let prjMemberList = await getProjectMemberList([], null, ticketDetail?.affiliationProject)

        let assigneeList = getAssignList(prjMemberList, currentUserDetail);
        setAssignList(assigneeList);

        if (!Utils.isEmptyObject(ticketDetail?.personInChargeInfo)) {
            if (ticketDetail?.personInChargeInfo?.avatar) {
                let avatarData = await Storage.get(ticketDetail?.personInChargeInfo?.avatar);
                ticketDetail.personInChargeInfo = {
                    ...ticketDetail.personInChargeInfo,
                    avatar: avatarData
                }
            }
    
            setCurrentAssigneeUserData({
                ...ticketDetail?.personInChargeInfo,
                assigneeIcon: ticketDetail?.personInChargeInfo?.shortName,
                assigneeFullName: ticketDetail?.personInChargeInfo?.fullName
            });
        } else {
            setCurrentAssigneeUserData({});
        }
    }


    // handle get init ticketDetail
    useEffect(() => {

        handleGetTicketDetail()
    }, []);

    // handle get init ticketDetail when have trigger reload
    useEffect(() => {
        // console.log('useEffect 1')
        if (
            props.triggerReload ||
            triggerReLoadKnowledgeTicketDetail === props.ticketId
        ) {
            handleGetTicketDetail()

            setTriggerReLoadKnowledgeTicketDetail('');
        }
    }, [props.triggerReload, triggerReLoadKnowledgeTicketDetail])

    useEffect(() => {
        // console.log('useEffect 2')
        // save listFieldEdited to panel
        if (listFieldEdited.length) {
            const newlistFieldEdited = [...new Set([ ...(currentTabData?.listFieldEdited || []), ...listFieldEdited])];
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'listFieldEdited', newlistFieldEdited);
        }
    }, [listFieldEdited]);

    useEffect(() => {
        // console.log('useEffect 3')
        if (
            props.tabId === closeTabIdState ||
            (props.componentName === Constant.COMPONENT_NAME.DETAIL_TICKET_KNOWLEDGE &&
                closeTabIdState === detailTicket.id
            )
        ) { 
            if (isEdited) {
                setIsConfirmCancelEditTicket(true);
            } else {
                const closePanelParams = {
                    isEdited: isEdited, 
                    setIsOpenPopupConfirm: setIsConfirmCancelEditTicket, 
                    panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL, 
                    panelId: props.panelId, 
                    detailTicket: detailTicket, 
                    panelList: panelList,   
                    closePanelTab: closePanelTab, 
                    setCloseTabIdState: setCloseTabIdState,
                    removePanelInitData: removePanelInitData,
                    panelInitData: panelInitData,
                    setPanelInitData: setPanelInitData
                }
                closePanelTabDetailTicket(closePanelParams);
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        // console.log('useEffect 4')
        if (isLoading) {
            return showLoadingMouse();
        } 
        return hideLoadingMouse();
    
     }, [isLoading]);

     


    //  Switch tab
    useEffect(() => {
        // console.log('useEffect 5')
        if (lastActivePanelId && lastActivePanelId.panelId === props.panelId && isEdited) {
            let formData = getValuesEditTicket();
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'formData', formData);
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
            updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUploadList', fileUploadList);
        }
    }, [lastActivePanelId, isEdited]);

    useEffect(() => {
        // console.log('useEffect 6')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'isEditedData', isEdited);
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'corporationSelectedId', props?.corporationSelectedId);
    }, [isEdited])

    useEffect(() => {
        // console.log('useEffect 7')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUploadList', fileUploadList);
    }, [fileUploadList])
    
    useEffect(() => {
        clearErrors();
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'displayMode', displayMode);
    }, [displayMode])

    useEffect(() => {
        // console.log('useEffect 8')
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'fileUpdatedList', fileUpdatedList);
        if(!Utils.isEmptyObject(currentPanelInitData) && currentPanelInitData?.hasOwnProperty('fileUpdatedList')){
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData)
            currentPanelInitDataClone.fileUpdatedList = [...fileUpdatedList]
            setCurrentPanelInitData({...currentPanelInitDataClone})
        }
    }, [fileUpdatedList])

    useEffect(() => {
        // console.log('useEffect 9')
        let settingPermission = {
            viewPermission: viewPermissions,
            editPermission: editPermissions,
            additionalViewPermission: additionalViewPermissions,
            additionalEditPermission: additionalEditPermissions,
            chatPermission: chatPermission
        };
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'settingPermission', settingPermission);
    }, [viewPermissions, editPermissions, additionalViewPermissions, additionalEditPermissions, chatPermission]);

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'aiAutoSelectedData', aiAutoSelectedData);
    }, [aiAutoSelectedData])

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'sdautoSelectedData', sdautoSelectedData);
    }, [sdautoSelectedData])

    useEffect(() => {
        updatePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData, 'aiTelephoneSelectedData', aiTelephoneSelectedData);
    }, [aiTelephoneSelectedData])

    const bookmarkTargetType = useMemo(() => {
        return Utils.getBookmarkTargetTypeByTicketType(detailTicket?.ticketType);
    }, [detailTicket]);

    const getHyperLink = useCallback(() => {
        // console.log('useEffect 10', detailTicket)
        if (props.tabId.includes(Constant.TAB_PANEL_TYPE.KNOWLEDGE_CREATE_TICKET)) return;
        if (!detailTicket.id) return '';
        let uriObj = {};
        let projectList = [];
        let orgHasReadPermission = [];
        let userHasReadPermission = [];
    
        uriObj = {
            projectList,
            orgHasReadPermission,
            userHasReadPermission,
            keyFile: `/knowledge/${detailTicket.id}-vectordata.json`,
            publicAll: true
        };
    
        const enCodeUriObj = encodeURIComponent(
            crypto.AES.encrypt(JSON.stringify(uriObj), Constant.S3_URL_AES_ENCODE_KEY).toString()
        );
        const newUri = `/${enCodeUriObj}`;
        return `${process.env.REACT_APP_CLOUD_FRONT_URL}${newUri}`;
    }, [detailTicket]);
    
    const openChatThreadPanel = ticketDetail => {
        addNewPanel({
            //update
            type: Constant.PANEL_TYPE.KNOWLEDGE_CHATTHREAD,
            tabId: ticketDetail.id,
            props,
            ticketId: ticketDetail.id,
            ticketOutline: ticketDetail.outline,
            isTicketDeleted: !Utils.isEmptyString(ticketDetail?.deletedAt) ? true : false
        });
    };

    const getPanelType = () => {
        let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, panelList);
        if (currentPanelIndex === -1) return '';
        let currentPanel = panelList[currentPanelIndex];
        return currentPanel.type;
    };
    
    const getTicketListType = () => {
        return getPanelType() === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL
            ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
            : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST;
    };

    const setCurrentPanelInitDataFormData = (formData) => {
        let currentPanelInitDataClone = cloneDeep(currentPanelInitData);
        currentPanelInitDataClone.formData = { ...formData };
        setCurrentPanelInitData({ ...currentPanelInitDataClone });
    }

    const handleEditTicketSubmit = async (formData, closeTab) => {
        if (isDisableBtnSaveTicket()) {
            setCurrentPanelInitDataFormData(formData);
            setIsLoading(false);
            return;
        }

        setIsLoading(true);

        const detailTicketLatest = await getTicketById(props?.API, props.ticketId);
        let isDataChanged = isSettingPermissionChanged(detailTicket, detailTicketLatest);
        if (isDataChanged) {
            setCurrentPanelInitDataFormData(formData);
            setIsLoading(false);
            setIsOpenModalReloadPageMain(true);
            return;
        }
        
        let fields = Utils.getEditTicketData(formData, fieldListDefaultData, aiAutoSelectedData, sdautoSelectedData);
        if (validateExceedSizeOfFieldTicket(argsAll.fieldListDefaultData, argsAll.setFieldListDefaultData, fields, argsAll.setErrorMessageHeader)) {
            setCurrentPanelInitDataFormData(formData);
            argsAll.setIsLoading(false);
            return;
        }
        let tagField = fields.tagField;
        if (!Utils.isEmptyObject(tagField)) {
            for (const fieldId in tagField) {
                let listNewItem = [];
                for (const item of tagField[fieldId]) {
                    if (item?.isNewItem) {
                        const parentField = fieldListDefaultData.find(
                            field => field.fieldId === fieldId
                        );
                        const itemData = {
                            usage: Constant.FORM_USAGE.TAG,
                            name: JSON.stringify({
                                jp: {
                                    A: 'F',
                                    text: item.title
                                }
                            }),
                            affiliationOrganization: parentField.affiliationOrganization,
                            affiliationProject: parentField.affiliationProject,
                            affiliationField: parentField.id,
                            creator: currentUserDetail.id,
                            updator: currentUserDetail.id,
                            type: '',
                            structure: JSON.stringify({
                                isShowItemInTicket: true,
                                no: item.no
                            }),
                            viewForCustomer: JSON.stringify({}),
                            definition: Constant.FORM_DEFINITION.USER,
                            explanation: JSON.stringify({}),
                            usingProjects: parentField.usingProjects,
                            hitNumber: 0,
                            hasValue: true
                        };
                        listNewItem.push(itemData);
                    }
                }
                const listNewId = await bulkCreateTagItem(props?.API, listNewItem);
                fields[fieldId].push(...listNewId);
            }
        }
        delete fields.tagField;
        let updateData = {
            id: detailTicket.id,
            affiliationOrganization: detailTicket.affiliationOrganization
        };

        let fieldEdited = currentTabData?.listFieldEdited || [] || listFieldEdited;
        let newFieldEditedList = [...fieldEdited];
        // Add hidden field in form
        if (
            formDetail?.definition === Constant.FORM_DEFINITION.SYSTEM &&
            (Object.values(Constant.FORM_VARIANT.AI_AUTO).includes(formDetail?.definitionVariant) ||
                formDetail?.promptKnowledgeFormFlag === Constant.KNOWLEDGE_PROMPT_FLAG.IS_PROMPT)
        ) {
            //clear reasoning effort field value
            const reasoningEffortField = fieldListDefaultData?.find(field => field?.sysField === Constant.AI_AUTO.SYSTEM_FIELD.REASONING_EFFORT);
            if (reasoningEffortField) {
                newFieldEditedList.push(reasoningEffortField?.id);
                newFieldEditedList = [...new Set(newFieldEditedList)];
                if (!isShowReasoningEffortField(aiAutoSelectedData)) {
                    formData[reasoningEffortField?.id] = [];
                    fields[reasoningEffortField?.id] = [];
                }
            }

            if (formDetail?.definitionVariant === Constant.FORM_VARIANT.AI_AUTO.EVENT) {
                let fieldEventTypeChatThread = fieldListDefaultData.find(
                    field =>
                        field.sysField === Constant.AI_AUTO.SYSTEM_FIELD.CHAT_THREAD_TYPE_TRIGGER
                );
                let fieldAIPDFPageSplitStatus = fieldListDefaultData.find(
                    field =>
                        field.sysField === Constant.AI_AUTO.SYSTEM_FIELD.AI_PDF_PAGE_SPLIT_STATUS
                );
                if (fieldEventTypeChatThread) {
                    newFieldEditedList.push(fieldEventTypeChatThread?.id);
                    newFieldEditedList = [...new Set(newFieldEditedList)];
                    if (!isShowFieldEventTypeChatThread(aiAutoSelectedData)) {
                        formData[fieldEventTypeChatThread?.id] = [];
                        fields[fieldEventTypeChatThread?.id] = [];
                    }
                }
                if (fieldAIPDFPageSplitStatus) {
                    newFieldEditedList.push(fieldAIPDFPageSplitStatus?.id);
                    newFieldEditedList = [...new Set(newFieldEditedList)];
                    if (!isShowFieldAIPDFPageSplitStatus(aiAutoSelectedData)) {
                        formData[fieldAIPDFPageSplitStatus?.id] = [];
                        fields[fieldAIPDFPageSplitStatus?.id] = [];
                    }
                }
            }
        }

        let editedFieldValue = Utils.getFieldsValueEdited(formData, fields, mapDataIdToId);
        editedFieldValue = await Utils.putFieldDataToS3BeforeEditTicket(editedFieldValue, mapDataIdToId, fieldListDefaultData, detailTicket);
        
        const args = { ...argsAll, listFieldEdited: newFieldEditedList };
        const updateResult = await submitUpdateTicketKnowledge(
            props?.API,
            updateData,
            setIsLoading,
            setIsDisplayEditTicket,
            fileUploadList,
            fileUpdatedList,
            setFileUploading,
            setFileUploadList,
            detailTicket,
            fieldListDefaultData,
            formData,
            currentUserDetail,
            editedFieldValue,
            mapDataIdToId,
            false,
            args
        );
       
        
        if(!Utils.isEmptyObject(updateResult) && updateResult.errorCode == Constant.MSG_CM_DELETED_TICKET){
            setIsLoading(false);
            setIsOpenModalTicketDeleted(true)
            return
        }

        if (updateResult?.isConfirm) {
            setIsLoading(false);
            return;
        }
        if (
            !Utils.isEmptyObject(updateResult) &&
            [
                Constant.MSG_SD_DUPLICATED_SCRIPT_TITLE,
                Constant.MSG_APP_NAME_DUPLICATED
            ].includes(updateResult.errorCode)
        ) {
        
            let currentPanelInitDataClone = cloneDeep(currentPanelInitData);
            currentPanelInitDataClone.formData = { ...formData };
            setCurrentPanelInitData({ ...currentPanelInitDataClone });
            return setIsLoading(false);
        }

        const newArgsAll = {...argsAll, getValuesEditTicket, setCurrentPanelInitData, isFromEditTicket: true}
        let newTicketDetail = await getTicketDetailHandler(newArgsAll, detailTicket.id, props.panelId, props.tabId, panelInitData, []);
        
        setCurrentPanelInitData({});
        removePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData);
        updateTabNameAfterEditTicket(argsAll, newTicketDetail.outline, props.panelId, detailTicket.id);
        reloadTicketListByPanelType({
            panelType: getTicketListType()
                ? getTicketListType()
                : Constant.PANEL_TYPE.KNOWLEDGE_HELPDESK_TICKET_LIST
        });
        setIsEdited(false);
        setListFieldEdited([])
        setIsLoading(false);

        setIsOpenModalTicketDeleted(false)
        if (typeof closeTab === 'function') {
            closeTab({
                event: null,
                panelType: getPanelType(),
                panelId: props.panelId,
                tabId: detailTicket.id
            });
        }
        
        setCloseTabIdState(0);
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-CONTENT-SUCCESSFULLY'), {
            variant: 'success',
            autoHideDuration: 3000
        });
        setDisplayMode(Constant.DISPLAY_MODE.VIEW);
        await handleAfterGetTicketDetail(newTicketDetail);
    };

    const handleReRestoreSubmit = () => {
        const outlineField = fieldListDefaultData?.find(
            field => field?.sysField?.toLowerCase() === Constant.SYS_FIELD.OUTLINE
        );
        const appNameField = fieldListDefaultData?.find(
            field => field?.sysField?.toLowerCase() === Constant.SYS_FIELD.BUSINESS_APP_NAME
        );
        let fieldOutlineIdUpdate = [outlineField?.id || appNameField?.id];
        
        acceptRestoreKnowledgeTicket(
            API,
            detailTicket,
            currentUserDetail,
            argsAll,
            fieldOutlineIdUpdate
        )

        setRestoreTicketErrorPopupData({isOpen: false});
    }

    const cancelEditTicket = async e => {
        handleResetFormData();
        setFlagReset(true);
    };

    
    const handleResetFormData = () => {
        setCurrentPanelInitData({});
        removePanelInitData(props.panelId, props.tabId, panelInitData, setPanelInitData);
        let newFieldListDefaultData = cloneDeep(fieldListDefaultData);
        newFieldListDefaultData = newFieldListDefaultData.map(field => {
            if (!Utils.isEmptyObject(field.error)) {
                return { ...field, error: { isError: false, message: '' } };
            }
            return field;
        });
        setFieldListDefaultData(newFieldListDefaultData);

        if (!Utils.isEmptyArray(fieldListDefaultData)) {
            fieldListDefaultData.forEach(field => {
                if (!Utils.isEmptyObject(field)) {
                    setValueEditTicket(field.id, field.defaultValue);
                }
            });
        }

       

        // reset setting permission
        let dataSettingDefault = {
            viewPermission: detailTicket.viewPermission,
            editPermission: detailTicket.editPermission,
            additionalViewPermission: detailTicket.additionalViewPermission,
            additionalEditPermission: detailTicket.additionalEditPermission,
            chatPermission: detailTicket.chatPermission
        };
        setDataSettingDefaults(dataSettingDefault);

        // Reset AI Telephone selected data to default values
        // This fixes the issue where conditional fields remain visible after canceling edit
        const resetAiTelephoneData = {};
        if (!Utils.isEmptyArray(fieldListDefaultData)) {
            fieldListDefaultData.forEach(field => {
                if (!Utils.isEmptyObject(field) && field.defaultValue !== undefined) {
                    // Reset AI Telephone fields
                    if ([Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_TIME_PERIOD, Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_TIME,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_TIME,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE,
                    Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_DAY_OF_WEEKS].includes(field.sysField)) {
                        resetAiTelephoneData[field.id] = field.defaultValue;
                    }
                }
            });
        }
        // Clear all err
        setErrorMessageHeader('');
        clearErrors();
        setIsEdited(false);
        setFileUploadList([]);
        setListFieldEdited([])
        setAITelephoneSelectedData(prev => ({
            ...resetAiTelephoneData,
            selectedFormDetail: prev?.selectedFormDetail
        }));
    };

    const setShowButtonEditTicket = (value) => {
        let formData = getValuesEditTicket()
        handlerShowButtonEditTicket(value, argsAll, formData, aiTelephoneSelectedData)
    }

    const getDefaultValueOfField = fieldData => {
        if (fieldData.structure.UI === Constant.FIELD_UI.DROP_FILE) {
            return fieldData.defaultValue;
        }

        let defaultValue =
            currentPanelInitData.formData && currentPanelInitData.formData[fieldData.fieldId]
                ? currentPanelInitData.formData[fieldData.fieldId]
                : fieldData.defaultValue;

        return defaultValue;
    };

    const handleReloadTicketDeleted = async () => {
        setDisableButtonCallBack(true);
        await updateUserWorkspacePanel(detailTicket.id, false);

        window.location.reload();
    };

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            selectedProject.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setSelectedProject,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }

    const isActiveFormInProject = () => {
        return formDetail.usingProjects.includes(selectedProject.id);
    };

    const isProjectActiveAITelephoneAgent = () => {
        return Utils.isProjectOnAiTelephoneAgent(selectedProject) && Utils.isEnableSettingTelephoneAgent(corporationDetail);
    }

    const onClickDuplicate = async () => {
        if (!isActiveFormInProject()) {
            setIsOpenModalActiveForm(true);
        }
        else if(Utils.isSystemFormAITrainingPrompt(formDetail) && !selectedProject.isDesk){
            setIsOpenModalTelephoneAgentDisabled(true);
        }
        else if (!isProjectActiveAITelephoneAgent() && (Utils.isSystemFormAITelephonePrompt(formDetail) || Utils.isSystemFormAIAssistantPrompt(formDetail) || Utils.isSystemFormAITrainingPrompt(formDetail))) {
            setIsOpenModalTelephoneAgentDisabled(true);
        }
        else {
            setIsOpenModalActiveForm(false);
            await viewTicketKnowledgeDetailDuplicate(props, 'ticketId', addNewPanel, setLastUserAction, false, detailTicket);
        }
    }

    const handlerActiveForm = async () => {
        setIsOpenModalActiveForm(false);
        setIsLoading(true);
        // handler data active form
        await activeFormForDuplicate(props?.API, formList, selectedProject.id, formDetail, setFormList);
        // open tab duplicate
        await viewTicketKnowledgeDetailDuplicate(props, 'ticketId', addNewPanel, setLastUserAction, false, detailTicket);
        setIsLoading(false);
        return hideLoadingMouse();
    }

    const isDisableBtnSaveTicket = () => {
        let corporationSetting = Utils.convertJSONDataToObject(corporationDetail?.corporationSetting);
        let listChatGptModel = corporationSetting?.listChatGptModel;

        const isNotAllRequired = !isInputAllFieldRequiredWhenEditTicket(
            fieldListDefaultData,
            [...fileUploadList, ...fileUpdatedList],
            getValuesEditTicket,
            aiAutoSelectedData,
            listChatGptModel,
            sdautoSelectedData,
            aiTelephoneSelectedData
        );
        if (
            isNotAllRequired ||
            !Utils.isEmptyObject(errorEditTicket)
        ) {
            return true;
        }

        return !(isEdited && isEditTicket);
    }
    
    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = Utils.getShareLinkImg({
            attachFile: openFileOption,
            dataShareLink: detailTicket.dataShareLink
        });

        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);
        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [detailTicket, openFileOption]);


    return (
        <div style={{ height: '100%' }}>
            {isLoading ? (
                <LoadingPanel isLoading={isLoading} />
            ) : (
                <div className="mainWrap detail-ticket-knowledge-body">
                    <DetailKnowledgeGroupActionButton
                        hasEditFieldPermissions={hasEditFieldPermissions}
                        hasEditSettingPermissions={hasEditSettingPermissions}
                        detailTicket={detailTicket}
                        userDetail={currentUserDetail}
                        setIsOpenDialogConfirmBackToDraft={setIsOpenDialogConfirmBackToDraft}
                        isDisableBtnSaveTicket={isDisableBtnSaveTicket}
                        submitEditTicket={handleSubmitEditTicket(handleEditTicketSubmit)}
                        setIsShowDialogRestoreTicket={setIsShowDialogRestoreTicket}
                        displayMode={displayMode}
                        setDisplayMode={setDisplayMode}
                        isEdited={isEdited}
                        cancelEditTicket={cancelEditTicket}
                    />

                    <div className="scrollBar-main detailTicketKnowledge flex-column">
                        {!Utils.isEmptyString(detailTicket.deletedAt) && (
                            <div className="form-addTicket">
                                <div className="alert-complete-delete-ticket">
                                    <p>
                                        本チケットは削除した日付から30日以内で復元可能です。
                                        <br />
                                        {moment(detailTicket.deletedAt)
                                            .add(30, 'days')
                                            .format('YYYY/MM/DD')}
                                        に自動的に完全削除されます。
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="titleTicket title-ticket-knowledge">
                            {/* Bookmark */}
                            <TagDefaultBookmark
                                className={'ticket-knowledge-detail-tag-default'}
                                isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                ticketKnowledge={detailTicket}
                                corporationDetail={corporationDetail}
                                projectInuseDetail={selectedProject}
                                userDetail={currentUserDetail}
                                setTriggerReloadKnowledgeListPanel={reloadTicketListByPanelType}
                                bookmarkTargetType={bookmarkTargetType}
                            />

                            {/* Ticket Title */}
                            {titleLineNumber === 2 ? (
                                <label className="titleDisplay titleTicket-titlev2 title-knowledge-display">
                                    {ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                </label>
                            ) : (
                                <Tooltip
                                    title={ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                >
                                    <label className="titleDisplay titleTicket-titlev2 title-clamp title-knowledge-display">
                                        {ticketOutline ? ticketOutline : '[概要 (現在未記入)]'}
                                    </label>
                                </Tooltip>
                            )}

                            {/* Ticket Options */}
                            <DetailKnowledgeViewModeGroupButton
                                hasViewPermission={hasViewPermission}
                                hasEditFieldPermissions={hasEditFieldPermissions}
                                hasEditSettingPermissions={hasEditSettingPermissions}
                                hasChatPermission={hasChatPermission}
                                detailTicket={detailTicket}
                                setIsOpenDialogConfirmDeleteKnowledge={
                                    setIsOpenDialogConfirmDeleteKnowledge
                                }
                                setIsShowDialogDeleteTicket={setIsShowDialogDeleteTicket}
                                displayMode={displayMode}
                                setDisplayMode={setDisplayMode}
                                corporationAffiliationTicket={corporationAffiliationTicket}
                                onClickDuplicate={onClickDuplicate}
                                formDetail={formDetail}
                                selectedProject={selectedProject}
                                isGeneralUser={isGeneralUser}
                                openChatThreadPanel={openChatThreadPanel}
                                parentScreen={Constant.SCREEN_LIST.KNOWLEDGE_DETAIL}
                            />
                        </div>

                        {/* Bookmark */}
                        <div className="ticket-bookmark-info">
                            <Bookmark
                                isTicketBookmark={true}
                                isViewDelete={!Utils.isEmptyString(detailTicket.deletedAt)}
                                ticketKnowledge={detailTicket}
                                panelType={Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL}
                                isShowEdit={true}
                                bookmarkPopupContainerClassName={
                                    'reset-position-bookmark-popup-container'
                                }
                            />
                            <div className="ticket-bookmark-info-wrap">
                                <div className="ticket-bookmark-info-text-wrap">
                                    <TaggedBookmarkListName
                                        bookmarkListText={detailTicket?.bookmarkListText}
                                        className="ticket-bookmark-info-text"
                                    />
                                </div>

                                <UserTagPrivateBookmarkCount ticketKnowledge={detailTicket} />
                            </div>
                        </div>

                        {/* Ticket Form */}
                        <div className="addTicket addTicket-detail">
                            <ErrorMessageHeader message={errorMessageHeader} />
                            <FormProvider {...validateEditTicket}>
                                {!Utils.isEmptyArray(fieldListDefaultData) &&
                                    fieldListDefaultData
                                        ?.filter(
                                            field =>
                                                field.sysField !==
                                                    Constant.TICKET_DATA_ID.TICKET_ID &&
                                                (detailTicket.affiliationProject ===
                                                    selectedProject.id ||
                                                    field.publicForCustomer !==
                                                        Constant.SETTING_FORM_DEFAULT.DO_NOT_SHOW)
                                        )
                                        ?.map((fieldData, i, filteredArray) => {
                                            // Skip end fields of paired fields (rendered with start field)
                                            if (AI_TELEPHONE_SKIP_FIELDS.includes(fieldData.sysField)) {
                                                return null;
                                            }

                                            if (
                                                fieldData.sysField ===
                                                Constant.SYS_FIELD.PERSON_IN_CHARGE
                                            ) {
                                                return (
                                                    <AssigneeUI
                                                        setNewAssignee={setNewAssignee}
                                                        setIsEdited={setIsEdited}
                                                        assigneeUserData={currentAssigneeUserData}
                                                        setCurrentAssigneeUserData={
                                                            setCurrentAssigneeUserData
                                                        }
                                                        ticketDetail={detailTicket}
                                                        setNewAssigneeData={setNewAssigneeData}
                                                        isGeneralUser={isGeneralUser}
                                                        isManager={isProjectManager}
                                                        isDisplayButtonEditTicket={
                                                            hasEditFieldPermissions
                                                        }
                                                        assignList={assignList}
                                                        isHelpDesk={true}
                                                        setListFieldEdited={setListFieldEdited}
                                                        listFieldEdited={listFieldEdited}
                                                        setIsEditTicket={setIsEditTicket}
                                                        data={fieldData}
                                                        isShowIconCopyFieldId={false}
                                                        {...argsAll}
                                                        setFlagReset={setFlagReset}
                                                        isMe={isMe}
                                                        setIsMe={setIsMe}
                                                        isDisableAssign={!assignList.length}
                                                    />
                                                );
                                            }

                                            // Helper function to build props for a field
                                            const buildFieldProps = (field) => {
                                                // Find paired field ids for date auto-adjustment
                                                let pairedEndFieldId = null;
                                                let pairedStartFieldId = null;
                                                if (field.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE) {
                                                    const endField = filteredArray.find(f => 
                                                        f.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE
                                                    );
                                                    pairedEndFieldId = endField?.fieldId;
                                                }
                                                if (field.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_END_DATE) {
                                                    const startField = filteredArray.find(f => 
                                                        f.sysField === Constant.SYSTEM_FIELD.AI_TELEPHONE_RECEIVING_CALL_EXECUTION_START_DATE
                                                    );
                                                    pairedStartFieldId = startField?.fieldId;
                                                }

                                                return {
                                                    ...argsAll,
                                                    API: props?.API,
                                                    UI: field.structure.UI,
                                                    label: field.fieldLabel
                                                        ? Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.fieldLabel)
                                                        : '',
                                                    errorlist: errorEditTicket,
                                                    name: field.fieldId,
                                                    data: field,
                                                    defaultValue: getDefaultValueOfField(field),
                                                    triggerValidate: triggerValidate,
                                                    isEdited: isEdited,
                                                    setIsEdited: setIsEdited,
                                                    setListFieldEdited: setListFieldEdited,
                                                    listFieldEdited: listFieldEdited,
                                                    fileUploadList: fileUploadList,
                                                    setFileUploadList: setFileUploadList,
                                                    register: registerEditTicket,
                                                    setValue: setValueEditTicket,
                                                    clearErrors: clearErrors,
                                                    setFileUpdatedList: setFileUpdatedList,
                                                    fileUpdatedList: fileUpdatedList,
                                                    getValues: getValuesEditTicket,
                                                    editTicket: true,
                                                    detailTicket: detailTicket,
                                                    viewFromProjectOfEscalateTicket: false,
                                                    setShowButtonEditTicket: setShowButtonEditTicket,
                                                    isLoading: isLoading,
                                                    setIsLoading: setIsLoading,
                                                    hasEditFieldPermissions: hasEditPermissionWithSpecialCase(
                                                        field, detailTicket, selectedProject, isProjectManager, displayMode
                                                    ),
                                                    isDisableEdit: displayMode === Constant.DISPLAY_MODE.VIEW || !hasEditPermissionWithSpecialCase(
                                                        field, detailTicket, selectedProject, isProjectManager, displayMode
                                                    ) || false,
                                                    parentForm: formDetail,
                                                    isDisplaySplitPdfSwitch: Utils.isDisplaySplitPdfSwitch(corporationDetail),
                                                    projectInuseDetail: selectedProject,
                                                    currentUserDetail: currentUserDetail,
                                                    isShowIconCopyFieldId: false,
                                                    onClickUrlViewTicket: onClickUrlViewTicket,
                                                    optionsOfTagField: optionsOfTagField,
                                                    setOptionsOfTagField: setOptionsOfTagField,
                                                    aiAutoSelectedData: aiAutoSelectedData,
                                                    sdautoSelectedData: sdautoSelectedData,
                                                    setSdautoSelectedData: setSdautoSelectedData,
                                                    setAIAutoSelectedData: setAIAutoSelectedData,
                                                    aiTelephoneSelectedData: aiTelephoneSelectedData,
                                                    setAITelephoneSelectedData: setAITelephoneSelectedData,
                                                    isSystemSDAutoForm: Utils.isSystemSDAutoForm(formDetail),
                                                    sysField: fieldData.sysField,
                                                    fieldListData: fieldListDefaultData,
                                                    selectedFormDetail: formDetail,
                                                    allFormData: allFormData,
                                                    pairedEndFieldId: pairedEndFieldId,
                                                    pairedStartFieldId: pairedStartFieldId,
                                                    aiTelephoneEndDateValue: aiTelephoneEndDateValue,
                                                    setAiTelephoneEndDateValue: setAiTelephoneEndDateValue,
                                                    affiliationProjectOfTicket: ticketAffiliationProject
                                                };
                                            };

                                            // Check if this is a paired start field
                                            const pairedEndFieldSysField = AI_TELEPHONE_PAIRED_FIELDS[fieldData.sysField];
                                            if (pairedEndFieldSysField) {
                                                const endFieldData = filteredArray.find(f => f.sysField === pairedEndFieldSysField);
                                                if (endFieldData) {
                                                    // Render both fields in a flex row
                                                    return (
                                                        <Box 
                                                            key={fieldData.fieldId}
                                                            display="flex" 
                                                            flexDirection="row" 
                                                            style={{ width: '100%', gap: '16px' }}
                                                        >
                                                            <Box style={{ flex: 1, minWidth: 0 }}>
                                                                <WrapRenderFieldUI {...buildFieldProps(fieldData)} />
                                                            </Box>
                                                            <Box style={{ flex: 1, minWidth: 0 }}>
                                                                <WrapRenderFieldUI {...buildFieldProps(endFieldData)} />
                                                            </Box>
                                                        </Box>
                                                    );
                                                }
                                            }

                                            // Normal single field render
                                            return (
                                                <WrapRenderFieldUI
                                                    key={i}
                                                    {...buildFieldProps(fieldData)}
                                                />
                                            );
                                        })}

                                <AttachFileChatPost
                                    detailTicket={detailTicket}
                                    fieldListDefaultData={fieldListDefaultData}
                                    setOpenPreviewImage={setOpenPreviewImage}
                                    setOpenFileOption={setOpenFileOption}
                                    setOpenOption={setOpenOption}
                                />
                            </FormProvider>

                            <SettingPermissionKnowledgeTicket
                                {...argsAll}
                                parentScreen={'EditTicket'}
                                dataSettingDefaults={dataSettingDefaults}
                                hasEditSettingPermissions={hasEditSettingPermissions}
                                detailTicket={detailTicket}
                                displayMode={displayMode}
                            />

                            {/* AI_AUTO_LOG */}
                            {isShowAiAutoLog &&
                                userOfProjectList.some(
                                    prj => prj.id === detailTicket.affiliationProject
                                ) && (
                                    <AiAutoLog
                                        corporationDetail={corporationDetail}
                                        selectedProject={selectedProject}
                                        currentUserDetail={currentUserDetail}
                                        ticketDetail={detailTicket}
                                        panelId={props.panelId}
                                        isDisabled={false}
                                    />
                                )}

                            {/* SD_AUTO_LOG */}
                            {isShowSDautoLog &&
                                userOfProjectList.some(
                                    prj => prj.id === detailTicket.affiliationProject
                                ) && (
                                    <div className={hasEditSettingPermissions ? '' : 'sd-auto-log-wrapper'}>
                                        <SDautoLog
                                            corporationDetail={corporationDetail}
                                            selectedProject={selectedProject}
                                            currentUserDetail={currentUserDetail}
                                            ticketDetail={detailTicket}
                                            panelId={props.panelId}
                                            isDisabled={false}
                                        />
                                    </div>
                            )}

                            {isShowAITelephonePromptLog &&
                                userOfProjectList.some(
                                    prj => prj.id === detailTicket.affiliationProject
                                ) && (
                                    <div
                                        className={
                                            !hasEditSettingPermissions &&
                                            'telephone-prompt-log-warp'
                                        }
                                    >
                                        <TelephonePromptLog
                                            corporationDetail={corporationDetail}
                                            selectedProject={selectedProject}
                                            currentUserDetail={currentUserDetail}
                                            ticketDetail={detailTicket}
                                            panelId={props.panelId}
                                            isDisabled={false}
                                        />
                                    </div>
                            )}
                            {/* Extracted text area */}
                            {/* View 3 field: Extract/Vector/Token */}
                            {isShowExtractedText &&
                                (hasEditSettingPermissions || hasEditFieldPermissions) &&
                                (isDisplayExtractText(corporationAffiliationTicket, props.tabId) ||
                                    isDisplayVectorUrlAndTotalToken(
                                        corporationAffiliationTicket,
                                        props.tabId
                                    )) && (
                                    <div className="setting-permission-body">
                                        <div className="setting-ticket-item">
                                            <span>{I18n.get('CM-LABEL-SYSTEM-ITEMS')}</span>
                                        </div>
                                        {isDisplayExtractText(
                                            corporationAffiliationTicket,
                                            props.tabId
                                        ) && (
                                            <div className="setting-ticket-item">
                                                <span>{I18n.get('HYPERLINK-EXTRACT-TEXT')}</span>
                                                <span></span>
                                            </div>
                                        )}
                                        {isDisplayVectorUrlAndTotalToken(
                                            corporationAffiliationTicket,
                                            props.tabId
                                        ) && (
                                            <>
                                                <div className="setting-ticket-item">
                                                    <span>{I18n.get('HYPERLINK-VECTOR-DATA')}</span>
                                                    <a
                                                        className="ticket-redirect"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href={getHyperLink()}
                                                    >
                                                        {getHyperLink() || ''}
                                                    </a>
                                                </div>

                                                <div className="setting-ticket-item">
                                                    <span>{I18n.get('CM-LABEL-TOKEN-NUMBER')}</span>
                                                    <span>{detailTicket?.totalToken}</span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                        </div>

                        {/* Ticket Footer */}
                        <div className="detail-ticketKnowledge-info">
                            <div className="detailTicket-footer">
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        <div className="detail-ticketKnowledge-form-label">
                                            {I18n.get('LABEL-FORMAT-NAME')}
                                        </div>
                                        <OverFlowTooltipWithTabsMui
                                            value={detailTicket?.usingFormName}
                                        />
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-form">
                                        {I18n.get('CM-LABEL-FORMAT-ID')} :
                                        <span
                                            className="id-detail-ticket-copy"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(formDetail?.id)
                                                    .then(() => {})
                                                    .catch(err => {});
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span className="field-form-id">{formDetail?.id}</span>
                                    </div>
                                </div>
                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        投稿日時：<span>{detailTicket?.createTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        投稿ユーザー：
                                        {/* <span>{detailTicket?.createrUserName}</span> */}
                                        <Tooltip title={detailTicket?.createrUserName}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {detailTicket?.createrUserName}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>

                                <div className="detail-ticketKnowledge-info-child">
                                    <div className="detail-ticketKnowledge-info-time">
                                        更新日時：<span>{detailTicket?.updatedTime}</span>
                                    </div>
                                    <div className="detail-ticketKnowledge-info-user">
                                        更新ユーザー：
                                        {/* <span>{detailTicket?.updatorUserName}</span> */}
                                        <Tooltip title={detailTicket?.updatorUserName}>
                                            <span
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    width: '55px'
                                                }}
                                            >
                                                {detailTicket?.updatorUserName}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="id-detail-ticket-footer">
                                    {!isShowExtractedText &&
                                        (hasEditSettingPermissions || hasEditFieldPermissions) &&
                                        (isDisplayExtractText(
                                            corporationAffiliationTicket,
                                            props.tabId
                                        ) ||
                                            isDisplayVectorUrlAndTotalToken(
                                                corporationAffiliationTicket,
                                                props.tabId
                                            )) && (
                                            <div
                                                className={
                                                    isShowExtractedText
                                                        ? 'show-extract-text-btn hidden'
                                                        : 'show-extract-text-btn'
                                                }
                                                onClick={e => setIsShowExtractedText(true)}
                                            >
                                                詳細
                                            </div>
                                        )}
                                    <div className="footer-ticket-id-data">
                                        <span className="id-detail-ticket-title">
                                            {I18n.get('USER04LB004')} :
                                        </span>
                                        <span
                                            className="id-detail-ticket-copy"
                                            onClick={async () => {
                                                navigator.clipboard
                                                    .writeText(detailTicket?.id)
                                                    .then(() => {})
                                                    .catch(e =>
                                                        console.log('copy ticketId e :>> ', e)
                                                    );
                                            }}
                                        >
                                            <img src="/assets/image/icon-copy.svg" alt="" />
                                        </span>
                                        <span id="ticketId">{detailTicket?.id}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Dialog group */}
            <DialogConfirmCancelEditTicket
                saveAndCancel={handleSubmitEditTicket(async data => {
                    await handleEditTicketSubmit(data);
                })}
                cancelEditTicket={cancelEditTicket}
                isConfirmCancelEditTicket={isConfirmCancelEditTicket}
                setIsConfirmCancelEditTicket={setIsConfirmCancelEditTicket}
                setCloseTabIdState={setCloseTabIdState}
                detailTicket={detailTicket}
                handleCancelTicket={() => {
                    setIsConfirmCancelEditTicket(false);
                    const closePanelParams = {
                        isEdited: false,
                        setIsOpenPopupConfirm: setIsConfirmCancelEditTicket,
                        panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_DETAIL,
                        panelId: props.panelId,
                        detailTicket: detailTicket,
                        panelList: panelList,
                        closePanelTab: closePanelTab,
                        setCloseTabIdState: setCloseTabIdState,
                        removePanelInitData: removePanelInitData,
                        panelInitData: panelInitData,
                        setPanelInitData: setPanelInitData
                    };
                    closePanelTabDetailTicket(closePanelParams);
                }}
            />

            <DataChangePleaseReloadModal
                setCloseTabIdState={setCloseTabIdState}
                isOpen={isOpenModalReloadPageMain}
                setIsOpen={setIsOpenModalReloadPageMain}
            />

            {/* Dialog Soft Delete */}
            <ConfirmDialog
                isOpen={isOpenDialogConfirmDeleteKnowledge}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT')}
                closeCallBack={(e, reason) =>
                    closeCallbackDeleteKnowledgeButton(e, reason, argsAll)
                }
                okCallBack={() => {
                    acceptDeleteKnowledgeButton(
                        props?.API,
                        detailTicket,
                        currentUserDetail,
                        argsAll
                    );
                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                }}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            {/* Dialog Draft Ticket */}
            <ConfirmDialog
                isOpen={isOpenDialogConfirmBackToDraft}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-BACK-TO-DRAFT')}
                closeCallBack={(e, reason) => closeCallbackBackToDraftButton(e, reason, argsAll)}
                okCallBack={() => {
                    acceptBackToDraftButton(props?.API, detailTicket, currentUserDetail, argsAll);
                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                }}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            <ConfirmDialog
                isOpen={isOpenModalTicketDeleted}
                msgConfirm={I18n.get('MSG-CM-DELETED-TICKET')}
                okCallBack={handleReloadTicketDeleted}
                disableButtonCallBack={disableButtonCallBack}
            />

            {/* Dialog Restore Ticket */}
            <ConfirmDialog
                isOpen={isShowDialogRestoreTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-RESTORE-CONTENT')}
                closeCallBack={(e, reason) =>
                    closeCallbackRestoreKnowledgeTicketButton(e, reason, argsAll)
                }
                okCallBack={() => {
                    acceptRestoreKnowledgeTicket(
                        props?.API,
                        detailTicket,
                        currentUserDetail,
                        argsAll
                    );
                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                }}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            {/* Hard Delete ticket */}
            <ConfirmDialog
                isOpen={isShowDialogDeleteTicket}
                msgConfirm={I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-COMPLETELY')}
                closeCallBack={() => setIsShowDialogDeleteTicket(false)}
                okCallBack={() => {
                    acceptHardDeleteKnowledgeTicket(
                        props?.API,
                        detailTicket,
                        currentUserDetail,
                        argsAll,
                        setIsOpenModalReloadPageMain,
                        setDisplayMode
                    );
                }}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                textClose={I18n.get('CM-BUTTON-CANCEL')}
            />

            {/* Dialog Access Denied*/}
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={I18n.get('KNOWDEMSG005')}
                okCallBack={() => handleConfirmAccessDenied(setIsOpenAccessDeniedPopup)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <DataChangePleaseReloadModal
                {...argsAll}
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={I18n.get('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={'はい'}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={I18n.get('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenModalActiveForm}
                msgConfirm={I18n.get('MSG-KNOW-CONFIRM-MOVE-FORM-DUPLICATE').replace(
                    '「Form_name」',
                    formDetail?.name?.jp?.text
                )}
                okCallBack={() => handlerActiveForm()}
                closeCallBack={() => setIsOpenModalActiveForm(false)}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
            />
             <ConfirmDialog
                isOpen={isOpenModalActiveAITelephoneAgent}
                msgConfirm={I18n.get('MSG-KNOW-CONFIRM-MOVE-FORM-DUPLICATE').replace(
                    '「Form_name」',
                    formDetail?.name?.jp?.text
                )}
                okCallBack={() => handlerActiveForm()}
                closeCallBack={() => setIsOpenModalActiveAITelephoneAgent(false)}
                textSubmit={I18n.get('COMBTN002')}
                textClose={I18n.get('COMBTN007')}
            />
            <ConfirmDialog
                isOpen={isOpenModalTelephoneAgentDisabled}
                msgConfirm={I18n.get('MSG-KNOW-TELEPHONE-AGENT-DISABLED-DUPLICATE')}
                okCallBack={() => setIsOpenModalTelephoneAgentDisabled(false)}
                textSubmit={I18n.get('CM-BUTTON-OK')}
                isHiddenCloseBtn={true}
            />
            <ConfirmDialog
                isOpen={isShowPopupLogout}
                msgConfirm={
                    <div>
                        <span>{I18n.get('MSG-CM-EXPIRED-SESSION-1')}</span>
                        <br />
                        <span>{I18n.get('MSG-CM-EXPIRED-SESSION-2')}</span>
                    </div>
                }
                textSubmit={I18n.get('CM-BUTTON-OK')}
                okCallBack={() => signOut()}
                cancelCallBack={() => setIsShowPopupLogout(false)}
                cancelClassName={'btn-confirm-cancel'}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
            <ConfirmDialog
                isOpen={!!restoreTicketErrorPopupData?.isOpen}
                msgConfirm={restoreTicketErrorPopupData?.message}
                okCallBack={e => handleReRestoreSubmit()}
                textSubmit={I18n.get('CM-BUTTON-OK')}
            />

            <Popover
                open={Boolean(openOption) || false}
                anchorEl={openOption}
                onClose={() => {
                    setOpenFileOption(null);
                    setOpenOption(null);
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {openFileOption?.shortKey && (
                        <FlagMessageCopyLink
                            title={I18n.get('KNOWDEMSG002')}
                            placement="top-start"
                            arrow={true}
                            open={isShowFlagMessage}
                        >
                            <ButtonOption onClick={onClickCopyShareLink}>
                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 400,
                                        fontFamily: 'Zen Kaku Gothic New'
                                    }}
                                >
                                    {I18n.get('GET_URL')}
                                </span>
                            </ButtonOption>
                        </FlagMessageCopyLink>
                    )}
                </div>
            </Popover>

            <Dialog
                open={!!openPreviewImage}
                onClose={() => setOpenPreviewImage(null)}
                maxWidth="md"
            >
                <img
                    alt=""
                    src={openPreviewImage}
                    style={{
                        maxWidth: '90vw',
                        maxHeight: '90vh',
                        objectFit: 'contain'
                    }}
                />
            </Dialog>
        </div>
    );
}
